import { render } from "./Rankings.vue?vue&type=template&id=3f6ed335&scoped=true"
import script from "./Rankings.vue?vue&type=script&lang=js"
export * from "./Rankings.vue?vue&type=script&lang=js"

import "./Rankings.vue?vue&type=style&index=0&id=3f6ed335&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6ed335"]])

export default __exports__